<template>
	<a-spin :spinning="spinning">
		<a-upload
			:file-list="props.fileList"
			:accept="props.accept"
			:multiple="props.multiple"
			:disabled="props.disabled"
			:listType="props.listType"
			:maxCount="props.maxCount"
			:custom-request="uploadFile"
			:show-upload-list="{ showDownloadIcon: true }"
			:beforeUpload="props.beforeUpload"
			@preview="$TOOL.previewFile"
			@download="$TOOL.downloadFile"
			@remove="removeFile"
		>
			<!-- 默认插槽 -->
			<slot v-if="proxy.$slots.default"></slot>
			<!-- 默认自定义 -->
			<a-button v-else>
				<template #icon><plus-outlined /></template>
			</a-button>
			<!-- 自定义上传列表 -->
			<template v-if="proxy.$slots.itemRender" #itemRender="{ file, actions }">
				<slot name="itemRender" :file="file" :actions="actions"></slot>
			</template>
			<template #downloadIcon><download-outlined /></template>
		</a-upload>
	</a-spin>
</template>

<script setup name="uploadFile">
    import fileApi from '@/api/dev/fileApi'
	import { getCurrentInstance } from 'vue'
	const { proxy } = getCurrentInstance()
    // 父组件传递的参数
	const props = defineProps({
		// 上传文件之前
		beforeUpload: {
			type: Function,
			required: false
		},
        // 是否支持多选文件
		multiple: {
			type: Boolean,
			default: false,
			required: false
		},
		// 接受上传的文件类型
		accept: {
			type: String,
			default: null,
			required: false
		},
        // 是否禁用
        disabled: {
			type: Boolean,
			default: false,
			required: false
		},
        // 上传列表的内建样式，支持三种基本样式 text, picture 和 picture-card
        listType: {
			type: String,
			default: 'text',
			required: false
		},
		maxCount: {
			type: Number,
			default: null,
			required: false
		},
        // 附件数据
        fileList: {
            type: Array,
			default: [],
			required: false
        }
	})
	// 定义组件的自定义事件
	const emit = defineEmits({
		afterUpload: null,
		uploadSuccess: null
	})
	// 上传附件加载效果
	const spinning = $ref(false)
    // 上传附件
	const uploadFile = (data) => {
		spinning = true
		const fileData = new FormData()
		fileData.append('file', data.file)
		fileApi.fileUploadDynamicReturnId(fileData)
        .then(id => {
			data.onSuccess()
            getDetail(id)
        })
        .finally(() => {
            emit('afterUpload')
			spinning = false
        })
	}
	// 获取附件详情
	const getDetail = (id) => {
		fileApi.simpleDetail({id}).then(res => {
			props.fileList.push(res)
			emit('uploadSuccess', props.fileList)
		})
	}
	// 删除附件
	const removeFile = (file) => {
		let index = props.fileList.findIndex(i => i.id == file.id)
		props.fileList.splice(index, 1)
	}
</script>
